import {isFeatureEnabled} from '@github-ui/feature-flags'
import {Button, SkeletonBox} from '@primer/react'

import {MergeBoxSectionHeader} from './common/MergeBoxSectionHeader'
import styles from './AgentMergeSectionLoading.module.css'

export function AgentMergeSectionLoading() {
  return (
    <div aria-hidden="true" className={styles.Section} data-testid="agent-merge-loading">
      <MergeBoxSectionHeader
        icon={<SkeletonBox width="var(--base-size-32)" height="var(--base-size-32)" />}
        // Match the default section's text flow so the placeholder also reserves wrapped lines.
        title={<span className={styles.Text}>Copilot can watch this pull request</span>}
        subtitle={
          <span className={styles.Text}>
            Copilot can monitor this pull request for failed Actions workflows and merge conflicts and fix them
            automatically.
            {isFeatureEnabled('copilot_mission_control_agent_merge_feedback') && (
              <>
                {' '}
                <span className={styles.Feedback}>Give feedback</span>
              </>
            )}
          </span>
        }
        rightSideContent={
          <SkeletonBox height="auto">
            <Button as="span" className={styles.Control}>
              Watch and fix
            </Button>
          </SkeletonBox>
        }
      />
    </div>
  )
}
